import { createExternalAccountsLoader } from "./stripeExternalAccounts";
import { elakay_API } from "../../config";
import {decryptData}  from '../auth/elakayCryptage'

export const listePM_createStripeCusTomer = async (token, query = "") => {
    try{
   const response = await fetch(`${elakay_API}/stripe/listePM_crateCustomer${query}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({})
    })
  
      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const updateCustomer = async (token, info, query) => {
      try{
   const response = await  fetch(`${elakay_API}/stripe/CustomersUpdate?qr=${query}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const createPaymentIntent = async (token, paymentMethodReq) => {
    try{
   const response = await fetch(`${elakay_API}/stripe/createPaymentIntent`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(paymentMethodReq)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
  const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const AttachPaymentMethod = async (token, info) => {
     try{
   const response = await  fetch(`${elakay_API}/stripe/attachPaymentMethod`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
       
        body: JSON.stringify(info)
    })

      // Preserve Stripe/backend metadata so the modal can distinguish field,
      // decline, authentication, network and unexpected server errors.
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const details = typeof errorData.error === "object"
        ? errorData.error
        : {
            type: errorData.type,
            code: errorData.code,
            decline_code: errorData.decline_code,
            message: errorData.error || errorData.message,
          };
      return {
        success: false,
        status: response.status,
        error: details.message || "Unable to save this card.",
        errorDetails: details,
      };
    }
     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors de l'ajout de la carte :", err);
    return {
      success: false,
      status: 0,
      error: err.message || "Unable to reach the payment service.",
      errorDetails: {
        type: "network_error",
        message: err.message || "Unable to reach the payment service.",
      },
    };
  }
};


export const DeletePaymentMethod = async (token, info) => {
     try{
   const response = await fetch(`${elakay_API}/stripe/deletePaymentMethod`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
       
        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
   const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const CustomersRetrieve = async (token) => {
     try{
   const response = await  fetch(`${elakay_API}/stripe/CustomersRetrieve`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
       const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const get_client_secret = async (token) => {
     try{
   const response = await  fetch(`${elakay_API}/stripe/get_client_secret`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const createStripeAccount = (token, info) => {
    return fetch(`${elakay_API}/stripe/createStripeAccount`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },

        body: JSON.stringify(info)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const retrieveStripeAccount = async (token) => {
     try{
   const response = await  fetch(`${elakay_API}/stripe/retrieveStripeAccount`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const PaymentIntent = (token, info) => {
    return fetch(`${elakay_API}/stripe/payment-intent`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },

        body: JSON.stringify(info)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const retrievePayment = async (token, info) => {
      try{
   const response = await fetch(`${elakay_API}/stripe/retrievePaymentMethod`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },

        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const updatePayment = async (token, info) => {
     try{
   const response = await  fetch(`${elakay_API}/stripe/UpdatePaymentMethod`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },

        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const DeleteCuStID = (token) => {
    return fetch(`${elakay_API}/stripe/DeleteCuStID`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const getPaymentIntentView = async (token, id) => {
      try{
   const response = await  fetch(`${elakay_API}/stripe/payment-View/${id}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const ListaccountsOrcreateStripeAccount = async (token, info) => {
  
      try{
   const response = await fetch(`${elakay_API}/stripe/List_ACC_Or_CRE_STR_ACC`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const CreatBankAccounts = async (token, info) => {
   
    try{
   const response = await  fetch(`${elakay_API}/stripe/CreatBankAccounts`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })  

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const CreatExBankAccounts = async (token, info) => {
 
     try{
   const response = await  fetch(`${elakay_API}/stripe/CreatBankAccountsExternal`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

   const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const AccountLinks = async (token, info) => {
    try{
   const response = await fetch(`${elakay_API}/stripe/AccountLinks`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json();
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors de la création du lien de compte :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const DeleteBankAccounts = async (token, info) => {
    try{
   const response = await fetch(`${elakay_API}/stripe/DeleteBankAccounts`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json();
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors de la suppression du compte bancaire :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const UpdateBankAccounts = async (token, info) => {
    try{
   const response = await fetch(`${elakay_API}/stripe/UpdateBankAccounts`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json();
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors de la mise à jour du compte bancaire :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const DeleteBankAccountsExternal = async (token, info) => {
    try{
   const response = await fetch(`${elakay_API}/stripe/DeleteBankAccountsExternal`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json();
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors de la suppression du compte bancaire externe :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const UpdateBankAccountsExternal = async (token, info) => {
    try{
   const response = await fetch(`${elakay_API}/stripe/UpdateBankAccountsExternal`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json();
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors de la mise à jour du compte bancaire externe :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const getListBankAccounts = async (token) => {
    try{
   const response = await fetch(`${elakay_API}/stripe/listBankAccounts`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const postCreatePayout = async (token, info) => {

     try{
   const response = await fetch(`${elakay_API}/stripe/CreatePayout`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const postCreateTransfer = (token, info) => {
 
    return fetch(`${elakay_API}/stripe/CreateTransfer`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const getListExternalAccounts = createExternalAccountsLoader(async (token) => {
  try{
   const response = await fetch(`${elakay_API}/stripe/listExternalAccounts`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      if (errorData.code === "stripe_account_mode_mismatch") {
        return { success: false, code: errorData.code, error: errorData.error };
      }
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    // Was "Erreur lors du chargement des catégories" here -- copy-pasted
    // from an unrelated categories-loading wrapper, never updated for
    // this one (Stripe bank accounts). Dev-console diagnostic only, never
    // shown to the user (the actual message is `error` below).
    console.error("Erreur lors du chargement des comptes bancaires Stripe :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
});

/* ── Boutique — achat one-time ── */

const _post = async (url, token, body = {}) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Erreur");
    return data;
  } catch (err) {
    return { success: false, error: err.message };
  }
};

export const getMyShops = async (token) => {
  try {
    const response = await fetch(`${elakay_API}/stripe/my-shops`, {
      method: "GET",
      headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
    });
    if (!response.ok) { const e = await response.json(); throw new Error(e.error || "Erreur"); }
    return await response.json();
  } catch (err) {
    return {
      success: false,
      error: err.message,
      myCreated: [],
      myPurchased: [],
      editorsShops: [],
      defaultShops: [],
      myShopDefault: null
    };
  }
};

export const getShopPricing = async () => {
  try {
    const response = await fetch(`${elakay_API}/stripe/shop-pricing`, {
      method: "GET",
      headers: { Accept: "application/json" },
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Erreur");
    return data;
  } catch (err) {
    return { displayPrice: 35, downloadPrice: 15, downloadOwnPrice: 8.99, bothPrice: 45 };
  }
};

export const buyShopDisplay = async (token, pageId) =>
  _post(`${elakay_API}/stripe/shop-display/buy`, token, { pageId });

export const buyShopDownload = async (token, pageId, downloadType = "other") =>
  _post(`${elakay_API}/stripe/shop-download/buy`, token, { pageId, downloadType });

export const buyShopBoth = async (token, pageId) =>
  _post(`${elakay_API}/stripe/shop-both/buy`, token, { pageId });

// familyPassword : réservé aux comptes Family — contourne le droit
// d'affichage non acheté sur une de leurs propres boutiques (créée/achetée),
// après re-confirmation du mot de passe côté serveur.
export const setShopDefault = async (token, pageId = null, familyPassword = "") =>
  _post(`${elakay_API}/stripe/shop-default/set`, token, {
    pageId,
    ...(familyPassword ? { familyPassword } : {}),
  });
